// extracted by mini-css-extract-plugin
export default {"_":"order-status____1OE3r","isMinimal":"order-status_isMinimal__Rq+r4"};